export interface SymbolLookupRecentSearchOpenResolverOptions {
  readonly isOpen: boolean;
  readonly focusOnInput: boolean;
  readonly isSkipOpenOnFocus: boolean;
  readonly symbolInput: string | null | undefined;
}

/**
 * Decides whether the recent-search dropdown should be opened.
 */
export function shouldOpenRecentSearchDropdown(
  options: SymbolLookupRecentSearchOpenResolverOptions
): boolean {
  const {
    isOpen,
    focusOnInput,
    isSkipOpenOnFocus,
    symbolInput
  }: SymbolLookupRecentSearchOpenResolverOptions = options;

  const hasEmptyInput = symbolInput === null || symbolInput === '';

  return !isOpen && focusOnInput && !isSkipOpenOnFocus && hasEmptyInput;
}

